import { T } from "../themes";

export default function ComicCard({ children, style={}, hi }) {
  return (
    <div style={{
      background:hi?T.cardHi:T.card,
      borderRadius:T.radius,
      boxShadow:hi?`${T.shadow}, inset 0 1px 0 rgba(255,255,255,0.08)`:T.shadow,
      padding:24,marginBottom:18,...style}}>
      {children}
    </div>
  );
}
